export default "__VITE_ASSET__BvOsgEJD__"